/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { UsuarioInfoPersonalDto } from '../../models/usuario-info-personal-dto';

export interface PacientesControllerActualizarInformacionPersonal$Params {
      body: UsuarioInfoPersonalDto
}

export function pacientesControllerActualizarInformacionPersonal(http: HttpClient, rootUrl: string, params: PacientesControllerActualizarInformacionPersonal$Params, context?: HttpContext): Observable<StrictHttpResponse<void>> {
  const rb = new RequestBuilder(rootUrl, pacientesControllerActualizarInformacionPersonal.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'text', accept: '*/*', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return (r as HttpResponse<any>).clone({ body: undefined }) as StrictHttpResponse<void>;
    })
  );
}

pacientesControllerActualizarInformacionPersonal.PATH = '/api/pacientes/actualizar-informacion-personal';
